import { jsx as r, jsxs as b } from "react/jsx-runtime";
import { ListBoxSelect as m, Tooltip as f } from "@systemeio/ui";
import { useEditorState as x } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useMemo as H } from "react";
import { twMerge as L } from "tailwind-merge";
import { ToolbarSelectButton as v } from "../../components/content-controls/toolbar-select-button.mjs";
import { TOOLTIP_STYLES as p } from "../../constants/default-styles.mjs";
import T from "../../icons/line-height-icon.mjs";
import { i18n as u } from "../../i18n.mjs";
import { LINE_HEIGHT_TYPES as c, LINE_HEIGHT_ATTRIBUTE as E } from "./constants.mjs";
const y = [1, 1.15, 1.5, 2, 2.5, 3], h = () => y.map((t) => ({
  id: t,
  caption: `${t}`
})), g = (t) => {
  const n = t.attrs[E];
  return typeof n == "number" || typeof n == "string" ? n : null;
}, I = (t, n, s) => {
  if (!t || n === void 0 || s === void 0) return !1;
  if (n === s)
    return c.some((a) => t.isActive(a));
  let o = !1;
  return t.state.doc.nodesBetween(n, s, (a) => {
    if (c.includes(a.type.name))
      return o = !0, !1;
  }), o;
}, N = (t, n, s) => {
  if (!t || n === void 0 || s === void 0) return null;
  if (n === s) {
    const e = t.state.doc.resolve(n);
    for (let i = e.depth; i >= 0; i--) {
      const l = e.node(i);
      if (c.includes(l.type.name))
        return g(l);
    }
    return null;
  }
  let o = null, a = !1;
  return t.state.doc.nodesBetween(n, s, (e) => {
    if (c.includes(e.type.name)) {
      const i = g(e);
      return o === null ? o = i : o !== i && (a = !0), !1;
    }
  }), a ? null : o;
}, R = (t) => {
  const n = x({
    editor: t,
    selector: ({ editor: e }) => {
      const i = e == null ? void 0 : e.state.selection.from, l = e == null ? void 0 : e.state.selection.to;
      return {
        isDisabled: !(e != null && e.options.editable) || !I(e, i, l),
        lineHeight: N(e, i, l)
      };
    }
  }), s = (n == null ? void 0 : n.isDisabled) ?? !1, o = (n == null ? void 0 : n.lineHeight) ?? null;
  return H(() => {
    const e = (l) => {
      t && t.chain().focus().setLineHeight(l).run();
    }, i = (l, d) => /* @__PURE__ */ r("div", { className: "flex items-center", children: /* @__PURE__ */ r(v, { className: "flex gap-1", disabled: s, open: l, children: /* @__PURE__ */ b("div", { className: "flex items-center justify-center gap-1", children: [
      /* @__PURE__ */ r(
        T,
        {
          className: L(
            "main-transition-colors h-3.5 w-3.5",
            s ? "fill-text-secondary" : "fill-text-primary group-hover:fill-brand-primary"
          )
        }
      ),
      d
    ] }) }) });
    return {
      toolbarRender: /* @__PURE__ */ r(
        m,
        {
          optionsProps: { unmount: !1 },
          optionsClassName: "min-w-[100px] w-[100px]",
          disabled: s,
          value: o,
          onChange: e,
          data: h(),
          children: (l) => /* @__PURE__ */ r(
            f,
            {
              disabled: s,
              label: u.t("line_height"),
              anchor: "left",
              ...p,
              children: i(l)
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ r(
        m,
        {
          optionsProps: { unmount: !1 },
          optionsClassName: "z-40 min-w-[100px] w-[100px]",
          disabled: s,
          value: o,
          onChange: e,
          data: h(),
          children: (l) => /* @__PURE__ */ r(
            f,
            {
              disabled: s,
              label: u.t("line_height"),
              anchor: "left",
              ...p,
              children: i(l, u.t("line_height"))
            }
          )
        }
      )
    };
  }, [t, s, o]);
};
export {
  R as useLineHeightExtensionToolbar
};
